module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    ref: "container",
    staticClass: "container weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('dof-mask', {
    attrs: {
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.layoutClick($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-box weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "operate-box-item weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.onDelete($event)
      }
    }
  }, [_c('p', {
    staticClass: "operate-box-item-text weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.delTitle))])])])], 1) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-97c77c7c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97c77c7c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-operation-modal/index.vue
// module id = 659
// module chunks = 0 1